/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { IncidentCategoryControllerUpdateMutationResponse, IncidentCategoryControllerUpdatePathParams } from "../../models/incidentAgentController/IncidentCategoryControllerUpdate";

function getIncidentCategoryControllerUpdateUrl(id: IncidentCategoryControllerUpdatePathParams["id"]) {
  const res = { method: 'PATCH', url: `/api/v1/incident-agent/categories/${id}` as const }  
  return res
}

/**
 * {@link /api/v1/incident-agent/categories/:id}
 */
export async function incidentCategoryControllerUpdate(id: IncidentCategoryControllerUpdatePathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<IncidentCategoryControllerUpdateMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "PATCH", url : getIncidentCategoryControllerUpdateUrl(id).url.toString(), ... requestConfig })  
  return res.data
}